"use client";
import {IMGPW} from '@/config';
import {useTranslations} from 'next-intl';
import Image from 'next/image';
import {FC} from 'react';
import ScrollableList from '@/components/design-system/ScrollableList';

export const CompanyLogo: FC<{logoUrl: string; altText: string}> = ({
  logoUrl,
  altText,
}) => {
  return (
    <div className="mx-auto px-4">
      <div className="relative" style={{height: '200px'}}>
        <Image
          fill
          objectFit="contain"
          className="opacity-75"
          src={logoUrl}
          alt={altText}
        />
      </div>
    </div>
  );
};

const BarOfCompanies: FC = () => {
  const t = useTranslations('business');
  const data = [
    <CompanyLogo logoUrl={`${IMGPW}/logos/salesforce.png`} altText="Salesforce" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/electrolux.png`} altText="Electrolux" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/sky.png`} altText="Sky Group" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/facile.png`} altText="Facile.it" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/mckinsey.jpeg`} altText="McKinsey & Company" />,
    <CompanyLogo logoUrl={`${IMGPW}/logos/daikin.png`} altText="Daikin" />,
  ];

  // https://stackoverflow.com/questions/980855/inputting-a-default-image-in-case-the-src-attribute-of-an-html-img-is-not-vali
  return (
    <div className="section-container text-center my-12">
      <h2 className="mb-4 font-bold">
        {t('Index.parlano-di-noi')}
      </h2>
      <ScrollableList
        gap={8}
        autoPlay
        columns={{
          xxl: 5,
          xl: 5,
          lg: 4,
          md: 3,
          sm: 3,
          xs: 'auto',
        }}
        data={data}
        keyExtractor={(elem, index) => index.toString()}
        renderItem={(elem) => elem}
      />
    </div>
  );
};

export default BarOfCompanies;
